var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company__item" }, [
    _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "med p-black" }, [
        _c("b", [_vm._v(_vm._s(_vm.companyItem.title))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "company__logo" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: { name: "companyPage", params: { id: _vm.companyItem.id } }
            }
          },
          [
            _c("img", {
              attrs: { src: _vm.companyItem.img, alt: _vm.companyItem.title }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "company__link" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: { name: "companyPage", params: { id: _vm.companyItem.id } }
            }
          },
          [
            _vm._v(
              "\n            Read more about " +
                _vm._s(_vm.companyItem.title) +
                "\n        "
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }